export function getPricing(beat) {
  const original = beat?.price ?? 0;
  const isFree = !!beat?.is_free;
  const discount = beat?.discount_percent || 0;
  const final = isFree
    ? 0
    : discount > 0
    ? Math.round(original * (1 - discount / 100) * 100) / 100
    : original;
  return { isFree, discount, original, final, hasDiscount: !isFree && discount > 0 };
}
